import axios from 'axios';
import router from '../router/index'
import { clearParentToken, rememberParentLoginRedirect } from '../utils/parentAuth'
import {
  Dialog,
  Toast
} from 'vant'
// 环境的切换
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = '/apis';
} else if (process.env.NODE_ENV == 'debug') {
  axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = 'http://api.yiguzheng.com.cn/';
}

// 请求超时时间
axios.defaults.timeout = 5000;
let reqNum = 0;
// 设置开始loading与结束loading
export function startLoading() {
  if (reqNum === 0) {
    Toast.loading({
      message: '',
      forbidClick: true,
      overlay: true
    });
  };
  reqNum++;
}
export function endLoading() {
  setTimeout(closeLoading, 300);
}
export function closeLoading() {
  if (reqNum <= 0) {
    return;
  } else {
    reqNum--;
  };
  if (reqNum === 0) {
    Toast.clear();
  }
}
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios进行了拦截封装取消
axios.defaults.withCredentials = false
//请求拦截器
axios.interceptors.request.use((param) => {
  startLoading();
  return param
}, (error) => {
  // 请求错误
  return Promise.reject(error)
})
// 返回拦截
axios.interceptors.response.use(response => {
  endLoading();
  if (response.data.code == 10100) {
    clearParentToken();
    if (router.currentRoute && router.currentRoute.path !== '/login') {
      rememberParentLoginRedirect(router.currentRoute.fullPath, true);
    }
    router.replace({
      path: '/login',
      query: router.currentRoute && router.currentRoute.path !== '/login' ? {
        redirect: router.currentRoute.fullPath
      } : {}
    })
    Dialog.alert({
      confirmButtonText: "我知道了",
      confirmButtonColor: "#E51C23",
      message: '通行证失效，请重新登陆'
    })
  };
  if (response.data.code == 40019) {
    localStorage.removeItem('PARENT_TOKEN');
    router.push({
      path: '/login'
    })
    Dialog.alert({
      confirmButtonText: "我知道了",
      confirmButtonColor: "#E51C23",
      message: '当前教师所在校区已冻结，请联系运营人员'
    })
  };
  if (response.data.code == 40020) {
    localStorage.removeItem('PARENT_TOKEN');
    router.push({
      path: '/login'
    })
    Dialog.alert({
      confirmButtonText: "我知道了",
      confirmButtonColor: "#E51C23",
      message: '当前教师已停运，请联系运营人员'
    })
  }
  return response
}, error => {
  endLoading();
  if (error.message.includes('timeout')) {
    Dialog.alert({
      confirmButtonText: "我知道了",
      confirmButtonColor: "#E51C23",
      message: '请求超时,请刷新当前页面!'
    });
  }
  // 错误提醒
  // Message.error(error.response.data.msg)

  // const {
  //   status
  // } = error.response.data.code
  // if (status == 88888 || response.data.code == 88887) {
  //   console.log('token过期或已在其他地方登陆!')
  // }
  return Promise.reject(error)
})
export default axios;



// WEBPACK FOOTER //
// ./src/apis/http.js